module.exports = __webpack_public_path__ + "img/logo.52079494.png";